import Bugsnag from "@bugsnag/js";
import { getQueryParams } from "@/utils/httpRequest";
import { referrerService } from "@/modules/contacts/features/referrer/store/services/referrer-service";
import { REFERRER_SERVICE_TAG } from "@/modules/contacts/features/referrer/utils/referrer-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const getReferrers = referrerService.injectEndpoints({
  endpoints: builder => ({
    getReferrers: builder.query({
      query: ({ params }) => `referrers?${getQueryParams(params)}`,
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ referrerId }) => ({ type: REFERRER_SERVICE_TAG, referrerId })),
              { type: REFERRER_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: REFERRER_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted({ params, setParams }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (!data.items.length && params.page > 1) {
            setParams(prevParams => ({ ...prevParams, page: prevParams.page - 1 }));
          }
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetReferrersQuery } = getReferrers;

